export const font = {
  fontFamily: {
    heading: ["Barlow Condensed"],
    sans: ["Poppins"],
  },

  fontWeight: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontSize: {
    xs: "10px",
    sm: "12px",
    base: "14px",
    md: "16px",
    lg: "18px",
    xl: "24px",
    xxl: "28px",
    xxxl: "40px",
  },

  letterSpacing: {
    tighter: "-0.02em",
    tight: "-0.01em",
    normal: "0em",
    wide: "0.02em",
    wider: "0.06em",
    widest: "0.1em",
  },

  lineHeight: {
    none: "1",
    tight: "1.1",
    snug: "1.3",
    normal: "1.5",
    relaxed: "1.7",
    loose: "2",
  },
};
